"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useSuspenseImage.default;
  }
});
var _useSuspenseImage = _interopRequireDefault(require("./useSuspenseImage"));
//# sourceMappingURL=index.js.map